import React, { useEffect, useState } from 'react';
import { Alert, Box, Button, Checkbox, Divider, FormControl, FormControlLabel, Grid, Icon, IconButton, InputLabel, MenuItem, Radio, RadioGroup, Select, TextField, Typography, useMediaQuery } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { checkboxColorSx, countryList, currencyArray, getAccountTypeLabel, getCurrencyLabel, institutionTransferType, provinceList, radioColorSx, radioOptionArray } from 'store/constant';
import { ToastContainer, toast } from 'react-toastify';
import axiosInstance from 'custom-axios';
import { useFullPageLoader } from 'hooks/useFullPageLoader';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { styled } from '@mui/material/styles';
import CloudDownload from '@mui/icons-material/CloudDownload';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faFileAlt, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { showConfirmSweetAlert } from 'hooks/useSweetAlert';

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});


const contentTypes = {
    'pdf': 'application/pdf',
    'jpg': 'image/jpeg',
    'jpeg': 'image/jpeg',
    'png': 'image/png'
};

const TransferInformation = ({ transferInfoRef, accountTypeId, formAccountData, userId, setFormAccountData, activeAccountStep, setActiveAccountStep }) => {
    const [loader, showLoader, hideLoader] = useFullPageLoader();
    const [addTransferDetails, setTransferDetails] = useState([...formAccountData.transfer_details]);
    const [selectedAccountTypeData, setSelectedAccountTypeData] = useState({ register_account_type: [], non_register_account_type: [] });
    const [hideFormData, setHideFormData] = useState(false)
    // const matchesMD = useMediaQuery((theme) => theme.breakpoints.down('md'));
    // let userId = localStorage.getItem('user_get_id')
    // const [accountTypeId, setAccountTypeId] = useState(1)
    // const [accountTypeData, setAccountTypeData] = useState(0)

    const {
        register,
        handleSubmit,
        setValue,
        trigger,
        control,
        formState: { errors }
    } = useFormContext();

    useEffect(() => {
        setValue('transfer_details', addTransferDetails);
    }, [addTransferDetails, setValue]);

    React.useImperativeHandle(transferInfoRef, () => ({
        triggerValidation: async () => {
            const isValid = await trigger(); // Ensure trigger is properly defined

            setFormAccountData(prevData => ({
                ...prevData,
                transfer_details: addTransferDetails // Ensure addTransferDetails is current
            }));

            return isValid;
        }
    }), [addTransferDetails]); // Add dependency


    /* const fetchAccountTypeData = async () => {
        try {
            const response = await axiosInstance.get(`api/get-user-account-type-info/${userId}`);

            if (response.data) {

                setAccountTypeData(response.data)

                // console.log(response.data)
            }
            // setLoadData(true)
        } catch (error) {
            // console.error(error.message);
        }
    } */

    const fetchTransferData = async () => {
        try {
            const response = await axiosInstance.get(`api/get-user-transfer-info/${userId}`);

            setHideFormData(response.is_applicable)

            setSelectedAccountTypeData({
                ...selectedAccountTypeData,
                register_account_type: response.accounts.register_account_type,
                non_register_account_type: response.accounts.non_register_account_type,
                spouse_register_account_type: response.accounts.spouse_register_account_type,
                spouse_non_register_account_type: response.accounts.spouse_non_register_account_type,
                transfer_instructions: response.accounts.transfer_instructions
            })


            const updatedTransferDetails = addTransferDetails.map((detail) => ({
                ...detail,
                non_register_account_type: response.accounts.non_register_account_type,
                register_account_type: response.accounts.register_account_type,
                spouse_register_account_type: response.accounts.spouse_register_account_type,
                spouse_non_register_account_type: response.accounts.spouse_non_register_account_type
            }));

            setTransferDetails(updatedTransferDetails);



            if (response.data.length > 0) {

                setFormAccountData(prevFormData => ({
                    ...prevFormData,
                    transfer_details: response.data
                }));

                setTransferDetails(response.data);
            }

        } catch (error) {
            // console.error(error.message);
        }
    }

    const uploadHandler = (e, transferIndex, instructionIndex) => {
        const file = e.target.files[0];
        const maxSize = 2 * 1024 * 1024; // 2 MB in bytes

        const allowedTypes = [
            'application/pdf',
            'image/jpeg',
            'image/png'
        ];

        let imageValidate = false;

        if (!allowedTypes.includes(file.type)) {
            toast.error('Unsupported file type. Only Pdf, Jpeg, and Png are allowed.');
            imageValidate = true
            return;
        }

        if (file.size > maxSize) {
            toast.error('File size is too large. Maximum 2 MB allowed.');
            imageValidate = true
            return;
        }

        if (!imageValidate) {
            showLoader();
            const reader = new FileReader();
            reader.onload = () => {
                const base64File = reader.result; // Base64 string
                const updatedPolicies = [...addTransferDetails];
                updatedPolicies[transferIndex].transfer_instructions[instructionIndex].ti_file = {
                    name: file.name, // Store the file name
                    file: base64File, // Store the Base64 string
                };
                setTransferDetails(updatedPolicies);
            };
            reader.readAsDataURL(file);
        }
    }

    const downloadAccountFile = async (_name, id) => {

        try {
            showLoader();
            const response = await axiosInstance.get(`api/download-account-statement-file/${id}/${userId}`, {
                responseType: 'blob',
                validateStatus: (status) => {
                    return status >= 200 && status < 500;
                },
            });

            // const contentType = response.headers['content-type'];
            const contentType = response.type;


            if (contentType === 'application/json') {

                const reader = new FileReader();
                reader.onload = () => {
                    const errorResponse = JSON.parse(reader.result);
                    toast.error(errorResponse.error || 'File not found.');
                };
                reader.readAsText(response.data);
            } else {

                const url = window.URL.createObjectURL(new Blob([response]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', _name);
                document.body.appendChild(link);
                link.click();
                link.remove();
            }

        } catch (error) {
            toast.error('An error occurred while downloading the file.');
            // console.error('Error downloading the file', error);

        } finally {
            hideLoader();
        }
    }

    const handleAccountFileSelect = (instructionId, fileId) => {
        setTransferDetails((prevDetails) =>
            prevDetails.map((detail) => ({
                ...detail,
                transfer_instructions: detail.transfer_instructions.map((instruction) =>
                    instruction.id === instructionId
                        ? {
                            ...instruction,
                            user_account_file: instruction.user_account_file.map((file) =>
                                file.id === fileId ? { ...file, selected: !file.selected } : file
                            ),
                        }
                        : instruction
                ),
            }))
        );
    };


    const handleTransferChange = (e, index) => {
        const { name, value } = e.target;
        const updatedPolicies = [...addTransferDetails];
        updatedPolicies[index][name] = value;
        setTransferDetails(updatedPolicies);
    };

    const handleAccountTypeChange = (field, value, checked, transferIndex, itemId) => {
        setTransferDetails(prevDetails => {
            const updatedDetails = [...prevDetails];
            const targetDetail = { ...updatedDetails[transferIndex] };

            const updatedAccountTypeList = targetDetail[field].map(item => {
                if (item.id === itemId) {
                    return { ...item, account_checked: checked };
                }
                return item;
            });

            targetDetail[field] = updatedAccountTypeList;
            updatedDetails[transferIndex] = targetDetail;

            return updatedDetails;
        });
    };


    const handleTransferInstructionChange = (e, transferIndex, instructionIndex) => {
        const { name, value } = e.target;
        const updatedPolicies = [...addTransferDetails];
        updatedPolicies[transferIndex].transfer_instructions[instructionIndex][name] = value;

        setTransferDetails(updatedPolicies);
    };

    const handleRoleBack = async () => {

        showLoader();
        let endPoint = `api/change-form-step`;

        const submitData = { user_id: userId ? userId : 0, parent_step: 1, child_step: activeAccountStep - 1 }

        try {
            const response = await axiosInstance.post(endPoint, submitData);

            if (response.status === 200) {
                setActiveAccountStep(activeAccountStep - 1);
            }

        } catch (error) {
            // console.error(error)
            toast.error('An error occurred when navigating back.')
        } finally {
            hideLoader();
        }
    };

    const getFileExtension = (fileName) => {
        return fileName.split('.').pop().toLowerCase();
    };

    const downloadFile = async (transferId, instructionId, _name) => {

        showLoader();
        try {
            const response = await axiosInstance.get(`api/download-transfer-file/${transferId}/${instructionId}/${userId}`, {
                responseType: 'blob',
                validateStatus: (status) => {
                    return status >= 200 && status < 500;
                },
            });


            const contentType = response['type'];

            if (contentType && contentType.includes('application/json')) {

                // Handle error response
                const reader = new FileReader();
                reader.onload = () => {
                    const errorResponse = JSON.parse(reader.result);
                    toast.error(errorResponse.error || 'An error occurred.');
                };
                reader.readAsText(response.data);
            } else {

                // Determine file extension and MIME type
                const extension = getFileExtension(_name);
                const mimeType = contentTypes[extension] || 'application/octet-stream';

                const url = window.URL.createObjectURL(new Blob([response], { type: mimeType }));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', _name);
                document.body.appendChild(link);
                link.click();
                link.remove();
            }


        } catch (error) {
            toast.error('An error occurred while downloading the file.');
            // console.error('Error downloading the file', error);

        } finally {
            hideLoader();
        }
    }

    const addTransferDetailsTemplate = () => {

        const resetAccountChecked = (accountTypeArray) => {
            return accountTypeArray.map((account) => ({
                ...account,
                account_checked: false, // Set account_checked to false
            }));
        };

        const newObject = {
            id: '',
            user_id: userId,
            account_type_id: accountTypeId,
            irrevocable_information: "",
            country: "",
            street_number: "",
            street_name: "",
            street_type: "",
            city: "",
            province: "",
            postal_code: "",
            business_phone: "",
            extension: "",
            dealer_number: "",
            institution_contact: "",
            // deep copy of the selectedAccountTypeData
            register_account_type: resetAccountChecked(selectedAccountTypeData.register_account_type),
            non_register_account_type: resetAccountChecked(selectedAccountTypeData.non_register_account_type),
            spouse_register_account_type: resetAccountChecked(selectedAccountTypeData.spouse_register_account_type),
            spouse_non_register_account_type: resetAccountChecked(selectedAccountTypeData.spouse_non_register_account_type),
            transfer_instructions: [...selectedAccountTypeData.transfer_instructions], // Shallow copy
        };


        setTransferDetails([...addTransferDetails, newObject]);
        /* const newObject = {
            id: '',
            user_id: userId,
            account_type_id: accountTypeId,
            irrevocable_information: "",
            country: "",
            street_number: "",
            street_name: "",
            street_type: "",
            city: "",
            province: "",
            postal_code: "",
            business_phone: "",
            extension: "",
            dealer_number: "",
            institution_contact: "",
            register_account_type: selectedAccountTypeData.register_account_type,
            non_register_account_type: selectedAccountTypeData.non_register_account_type,
            spouse_register_account_type: selectedAccountTypeData.spouse_register_account_type,
            spouse_non_register_account_type: selectedAccountTypeData.spouse_non_register_account_type,
            transfer_instructions: selectedAccountTypeData.transfer_instructions
            // transfer_instructions: [
            //     { instruction_currency: "", institution_account_number: "", institution_transfer_type: "", ti_file: '' }
            // ]
        };
        setTransferDetails([...addTransferDetails, newObject]); */
    };


    const addTransferInstruction = (transferIndex) => {
        const updatedPolicies = [...addTransferDetails];

        updatedPolicies[transferIndex].transfer_instructions.push({
            id: "",
            user_id: userId,
            ...selectedAccountTypeData.transfer_instructions[0]
        });
        setTransferDetails(updatedPolicies);
    };

    const removeTransferDetails = async (index, transferDetailsId) => {

        if (transferDetailsId) {
            const result = await showConfirmSweetAlert({
                title: 'Remove Item?',
                text: 'Are you sure you want to remove this?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, remove it!',
                cancelButtonText: 'No, cancel!',
            });

            if (result.isConfirmed) {

                showLoader();

                try {
                    const response = await axiosInstance.delete(`api/delete-transfer-details/${transferDetailsId}`);
                    if (response.status == 200) {
                        toast.success(response.message);
                        fetchAllApi();
                    } else {
                        toast.error('Something went wrong.');
                    }
                } catch (error) {
                    toast.error(error.message);
                } finally {
                    hideLoader();
                }
            }
        } else {
            const updatedTransferDetails = [...addTransferDetails];
            updatedTransferDetails.splice(index, 1);
            setTransferDetails(updatedTransferDetails);
        }
    }

    const removeTransferInstructionDetails = async (index, instructionId, transferId) => {
        if (instructionId) {
            const result = await showConfirmSweetAlert({
                title: 'Are you sure?',
                text: `You will not be able to recover this!`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!',
                cancelButtonText: 'No, cancel!',
            });

            if (result.isConfirmed) {
                showLoader();
                try {
                    const response = await axiosInstance.delete(`api/delete-transfer-instruction/${instructionId}`);
                    if (response.status == 200) {
                        toast.success(response.message);
                        fetchAllApi();
                    } else {
                        toast.error('Something went wrong.');
                    }
                } catch (error) {
                    toast.error(error.message);
                } finally {
                    hideLoader();
                }
            }
        } else {
            const updatedTransferDetails = [...addTransferDetails];
            updatedTransferDetails[transferId].transfer_instructions.splice(index, 1);
            setTransferDetails(updatedTransferDetails);
        }
    }

    /* const deleteFile = (id, transferIndex, instructionIndex) => {
    const updatedPolicies = [...addTransferDetails];
    updatedPolicies[transferIndex].transfer_instructions[instructionIndex].ti_file = ''; // Clear file name
    setTransferDetails(updatedPolicies);
    }; */

    const submitForm = async () => {

        showLoader();
        setFormAccountData(prevData => ({
            ...prevData,
            transfer_details: addTransferDetails
        }));

        let endPoint = `api/save-user-transfer-info`;


        const submitData = { add_transfer_details: addTransferDetails, accountTypeId: accountTypeId, user_id: userId ? userId : 0, parent_step: 1, child_step: activeAccountStep + 1 }


        try {
            const response = await axiosInstance.post(endPoint, submitData
                // { headers: { 'Content-Type': 'multipart/form-data'}}
            );
            if (response.status === 200) {
                setActiveAccountStep(activeAccountStep + 1);
            } else {
                toast.error('Something went wrong.');
            }

        } catch (error) {
            toast.error('Something went wrong. Please try again later.');
        } finally {
            hideLoader();
        }
    };

    const fetchAllApi = async () => {
        try {
            showLoader()
            await fetchTransferData()
            // await fetchAccountTypeData()
            hideLoader()

        } catch (error) {
            hideLoader()
        }
    }


    useEffect(() => {
        fetchAllApi()
    }, [])


    return (
        <div className='container  mt-5'>
            <form onSubmit={handleSubmit(submitForm)}>

                {hideFormData && addTransferDetails?.map((item, transferIndex) => (
                    <div key={transferIndex}>
                        <Grid
                            container
                            direction="row"
                            justifyContent="space-between"
                            alignItems="center"
                            className='form-head-gray-title'
                        >
                            <Grid item>
                                <Typography component='h3'>Transfer Details #{transferIndex + 1}</Typography>
                            </Grid>
                            <Grid item>
                                <IconButton title='Delete' sx={{ p: "0 10px 0 0" }} disabled={transferIndex == 0} onClick={() => removeTransferDetails(transferIndex, item.id)}>
                                    <DeleteIcon sx={{ color: '#dd4747' }} />
                                </IconButton>
                            </Grid>
                        </Grid>

                        <Grid item xs={12} className='align-content-center text-left mt-4'>
                            <label htmlFor="irrevocable-beneficiary" className='font15px bold-text'>Irrevocable Beneficiary Information</label>
                        </Grid>

                        <Grid container
                            sx={{
                                border: "1px solid #ced4da",
                                p: "10px",
                                mt: "10px"
                            }}>
                            <Grid item xs={12} sm={6} className='align-content-center text-left'>
                                <label htmlFor="irrevocable-beneficiary" className='font15px'>Is there an irrevocable beneficiary on the account at the delivering institution?</label>
                            </Grid>

                            <Grid item xs={12} sm={6} md={3}>
                                <FormControl component="fieldset">
                                    <RadioGroup
                                        row
                                        id='irrevocable-information'
                                        aria-labelledby="irrevocable_information"
                                        name='irrevocable_information'
                                        value={item.irrevocable_information}
                                        onChange={(e) => handleTransferChange(e, transferIndex)}
                                    >
                                        {radioOptionArray.map((option) => (
                                            <FormControlLabel
                                                key={option.value}
                                                value={option.value}
                                                control={<Radio sx={radioColorSx} />}
                                                label={option.label}
                                            />
                                        ))}
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12} md={3}></Grid>
                        </Grid>

                        {/* ------------------------PRIMARY ACCOUNT -------------------------------- */}
                        <Grid container className='p-4'>

                            {((addTransferDetails[transferIndex].non_register_account_type.length > 0) || (addTransferDetails[transferIndex].register_account_type.length > 0)) &&
                                <Grid item xs={12} sm={12} md={12}>
                                    <label className='label-text'>Primary's Account</label>
                                </Grid>
                            }

                            <Grid item xs={6} sm={6} md={6}>
                                {(addTransferDetails[transferIndex].non_register_account_type.length > 0) &&
                                    <label className='font15px margin-top10px'>Non-Registered Account</label>
                                }
                            </Grid>

                            <Grid item xs={6} sm={6} md={6}>
                                {(addTransferDetails[transferIndex].register_account_type.length > 0) &&
                                    <label className='font15px margin-top10px'>Registered Account</label>
                                }
                            </Grid>

                            <Grid item xs={6} sm={6} md={6}>
                                {(addTransferDetails[transferIndex].non_register_account_type.length > 0) &&
                                    <FormControl>
                                        <Controller
                                            name="item_ids_non_reg"
                                            {...register('pNonRegisterSubAccountType')}
                                            render={(props) =>
                                                addTransferDetails[transferIndex].non_register_account_type
                                                    ?.map((item, index) => (
                                                        <div className="d-flex" key={`${item.value}_${index}`}>
                                                            <input
                                                                className="asset_checkbox-1 width16px"
                                                                id={`non_reg_type${item.value}_${index}`}
                                                                type="checkbox"
                                                                onChange={(e) =>
                                                                    handleAccountTypeChange(
                                                                        'non_register_account_type',
                                                                        item.value,
                                                                        e.target.checked,
                                                                        transferIndex,
                                                                        item.id
                                                                    )
                                                                }
                                                                checked={item.account_checked}

                                                            />
                                                            <label
                                                                htmlFor={`non_reg_type${item.value}_${index}`}
                                                                className="non-reg-label"
                                                            >
                                                                {item.label}
                                                            </label>
                                                        </div>
                                                    ))
                                            }
                                            control={control}
                                        />
                                    </FormControl>
                                }
                            </Grid>

                            <Grid item xs={6} sm={6} md={6}>
                                {(addTransferDetails[transferIndex].register_account_type.length > 0) &&
                                    <FormControl>
                                        <Controller
                                            name="item_ids_reg"
                                            {...register('pRegisterSubAccountType')}
                                            render={(props) =>
                                                addTransferDetails[transferIndex].register_account_type
                                                    ?.map((item, index) => {
                                                        return (
                                                            <>
                                                                <div className="d-flex" key={`reg-${item.id}-${index}`}>
                                                                    <input
                                                                        className="asset_checkbox-1 width16px"
                                                                        id={`p_reg_account_type${item.value}_${index}_${transferIndex}`}
                                                                        type="checkbox"
                                                                        onChange={(e) =>
                                                                            handleAccountTypeChange(
                                                                                'register_account_type',
                                                                                item.value,
                                                                                e.target.checked,
                                                                                transferIndex,
                                                                                item.id
                                                                            )
                                                                        }
                                                                        checked={item.account_checked}

                                                                    />
                                                                    <label
                                                                        htmlFor={`p_reg_account_type${item.value}_${index}_${transferIndex}`}
                                                                        className="non-reg-label"
                                                                    >
                                                                        {item.label}
                                                                    </label>
                                                                </div>
                                                            </>
                                                        );
                                                    })
                                            }
                                            control={control}
                                        />
                                    </FormControl>
                                }
                            </Grid>
                        </Grid>

                        <Divider className='divider' />

                        {/* ------------------------SPOUSAL ACCOUNT -------------------------------- */}
                        <Grid container className='p-4'>
                            {((addTransferDetails[transferIndex].spouse_non_register_account_type.length > 0) || (addTransferDetails[transferIndex].spouse_register_account_type.length > 0)) &&
                                <Grid item xs={12} sm={12} md={12}>
                                    <label className='label-text'>Spouse's Account</label>
                                </Grid>
                            }
                            <Grid item xs={6} sm={6} md={6}>
                                {(addTransferDetails[transferIndex].spouse_non_register_account_type.length > 0) &&
                                    <label className='font15px margin-top10px'>Non-Registered Account</label>
                                }
                            </Grid>

                            <Grid item xs={6} sm={6} md={6}>
                                {(addTransferDetails[transferIndex].spouse_register_account_type.length > 0) &&
                                    <label className='font15px margin-top10px'>Registered Account</label>
                                }
                            </Grid>

                            <Grid item xs={6} sm={6} md={6}>
                                {(addTransferDetails[transferIndex].spouse_non_register_account_type.length > 0) &&
                                    <FormControl>
                                        <Controller
                                            name="item_ids_non_reg"
                                            {...register('pNonRegisterSubAccountType')}
                                            render={(props) =>
                                                addTransferDetails[transferIndex].spouse_non_register_account_type
                                                    ?.map((item, index) => (
                                                        <div className="d-flex" key={`${item.value}_${index}`}>
                                                            <input
                                                                className="asset_checkbox-1 width16px"
                                                                id={`spouse_non_register_account_type_${item.value}_${index}_${transferIndex}`}
                                                                type="checkbox"
                                                                onChange={(e) =>
                                                                    handleAccountTypeChange(
                                                                        'spouse_non_register_account_type',
                                                                        item.value,
                                                                        e.target.checked,
                                                                        transferIndex,
                                                                        item.id
                                                                    )
                                                                }
                                                                checked={item.account_checked}

                                                            />
                                                            <label
                                                                htmlFor={`non_reg_type${item.value}_${index}`}
                                                                className="non-reg-label"
                                                            >
                                                                {item.label}
                                                            </label>
                                                        </div>
                                                    ))
                                            }
                                            control={control}
                                        />
                                    </FormControl>
                                }
                            </Grid>

                            <Grid item xs={6} sm={6} md={6}>
                                {(addTransferDetails[transferIndex].spouse_register_account_type.length > 0) &&
                                    <FormControl>
                                        <Controller
                                            name="item_ids_reg"
                                            {...register('pRegisterSubAccountType')}
                                            render={(props) =>
                                                addTransferDetails[transferIndex].spouse_register_account_type
                                                    ?.map((item, index) => {
                                                        return (
                                                            <>
                                                                <div className="d-flex">
                                                                    <input
                                                                        className="asset_checkbox-1 width16px"
                                                                        // id={`reg_account_type${item.value}`}
                                                                        id={`s_reg_account_type${item.value}_${index}_${transferIndex}`}
                                                                        type="checkbox"
                                                                        onChange={(e) =>
                                                                            handleAccountTypeChange(
                                                                                'spouse_register_account_type',
                                                                                item.value,
                                                                                e.target.checked,
                                                                                transferIndex,
                                                                                item.id
                                                                            )
                                                                        }
                                                                        checked={item.account_checked}

                                                                    />
                                                                    <label
                                                                        htmlFor={`s_reg_account_type${item.value}_${index}_${transferIndex}`}
                                                                        className="non-reg-label"
                                                                    >
                                                                        {item.label}
                                                                    </label>
                                                                </div>
                                                            </>
                                                        );
                                                    })
                                            }
                                            control={control}
                                        />
                                    </FormControl>
                                }
                            </Grid>
                        </Grid>

                        <Grid container spacing={2} className='p-4'>
                            <Grid item xs={12} className='align-content-center text-left'>
                                <label htmlFor="irrevocable-beneficiary" className='font15px bold-text'>Delivering Institution Information</label>
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Street No"
                                    fullWidth
                                    size="small"
                                    name='street_number'
                                    onChange={(e) => handleTransferChange(e, transferIndex)}
                                    value={item.street_number}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Street Name"
                                    fullWidth
                                    size="small"
                                    name='street_name'
                                    onChange={(e) => handleTransferChange(e, transferIndex)}
                                    value={item.street_name}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Street Type"
                                    fullWidth
                                    size="small"
                                    name='street_type'
                                    onChange={(e) => handleTransferChange(e, transferIndex)}
                                    value={item.street_type}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="City"
                                    fullWidth
                                    size="small"
                                    name='city'
                                    onChange={(e) => handleTransferChange(e, transferIndex)}
                                    value={item.city}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth size="small">
                                    <InputLabel id="select-tpi-province">Province</InputLabel>
                                    <Select
                                        labelId="select-tpi-province"
                                        label="Province"
                                        value={item.province}
                                        name='province'
                                        MenuProps={{
                                            disableScrollLock: true,
                                            PaperProps: { sx: { maxHeight: 200 } }
                                        }}
                                        onChange={(e) => handleTransferChange(e, transferIndex)}
                                    >
                                        {provinceList.map((option) => (
                                            <MenuItem key={option.value} value={option.value}>
                                                {option.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth size="small">
                                    <InputLabel id="select-l-country">Country</InputLabel>
                                    <Select
                                        labelId="select-l-country"
                                        label="Country"
                                        value={item.country}
                                        name='country'
                                        MenuProps={{
                                            disableScrollLock: true,
                                            PaperProps: { sx: { maxHeight: 200 } }
                                        }}
                                        onChange={(e) => handleTransferChange(e, transferIndex)}
                                    >
                                        {countryList.map((option) => (
                                            <MenuItem key={option.value} value={option.value}>
                                                {option.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Postal Code"
                                    fullWidth
                                    size="small"
                                    name='postal_code'
                                    onChange={(e) => handleTransferChange(e, transferIndex)}
                                    value={item.postal_code}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Business Phone"
                                    fullWidth
                                    size="small"
                                    name='business_phone'
                                    onChange={(e) => handleTransferChange(e, transferIndex)}
                                    value={item.business_phone}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Extension"
                                    fullWidth
                                    size="small"
                                    name='extension'
                                    onChange={(e) => handleTransferChange(e, transferIndex)}
                                    value={item.extension}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Institution Contact"
                                    fullWidth
                                    size="small"
                                    name='institution_contact'
                                    onChange={(e) => handleTransferChange(e, transferIndex)}
                                    value={item.institution_contact}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Dealer Number"
                                    fullWidth
                                    size="small"
                                    name='dealer_number'
                                    onChange={(e) => handleTransferChange(e, transferIndex)}
                                    value={item.dealer_number}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}></Grid>

                            {item.transfer_instructions.map((instruction, instructionIndex) => (
                                <div className='beneficiary-box m-3 width100' key={instructionIndex}>
                                    <Grid
                                        container
                                        direction="row"
                                        justifyContent="space-between"
                                        alignItems="center"
                                        className='form-head-gray-title'
                                    >
                                        <Grid item>
                                            <Typography component='h3'>Transfer Instruction #{instructionIndex + 1}</Typography>
                                        </Grid>
                                        <Grid item>
                                            <IconButton title='Delete' onClick={() => removeTransferInstructionDetails(instructionIndex, instruction.id, transferIndex)}>
                                                <DeleteIcon sx={{ color: '#dd4747' }} />
                                            </IconButton>
                                        </Grid>
                                    </Grid>

                                    <Grid container spacing={2} className='p-3'>
                                        <Grid item xs={6}>
                                            <FormControl fullWidth size="small">
                                                <InputLabel id="select-tpi-instruction_currency">Currency</InputLabel>
                                                <Select
                                                    labelId="select-tpi-instruction_currency"
                                                    label="Currency"
                                                    name='instruction_currency'
                                                    value={instruction.instruction_currency || ''}
                                                    MenuProps={{
                                                        disableScrollLock: true,
                                                        PaperProps: { sx: { maxHeight: 200 } }
                                                    }}
                                                    onChange={(e) => handleTransferInstructionChange(e, transferIndex, instructionIndex)}
                                                >
                                                    {currencyArray.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                            {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>

                                        <Grid item xs={6}>
                                            <TextField
                                                label="Institution Account Number"
                                                fullWidth
                                                size="small"
                                                name='institution_account_number'
                                                onChange={(e) => handleTransferInstructionChange(e, transferIndex, instructionIndex)}
                                                value={instruction.institution_account_number}
                                            />
                                        </Grid>

                                        <Grid item xs={3}>
                                            <Typography component='h3' className='text-capitalize bold-text'>Receiving Institution Account</Typography>
                                        </Grid>

                                        {/* <Grid item xs={3}>
                                            <Typography component='h3'> {getCurrencyLabel(accountTypeData.account_currency)} - {getAccountTypeLabel(accountTypeData.account_type)}</Typography>
                                        </Grid> */}
                                        <Grid item xs={6}></Grid>

                                        <Grid item xs={6}>
                                            <FormControl fullWidth size="small">
                                                <InputLabel id="select-tpi-institution_transfer_type">Transfer Type</InputLabel>
                                                <Select
                                                    labelId="select-tpi-institution_transfer_type"
                                                    label="Transfer Type"
                                                    name='institution_transfer_type'
                                                    value={instruction.institution_transfer_type || ''}
                                                    MenuProps={{
                                                        disableScrollLock: true,
                                                        PaperProps: { sx: { maxHeight: 200 } }
                                                    }}
                                                    onChange={(e) => handleTransferInstructionChange(e, transferIndex, instructionIndex)}
                                                >
                                                    {institutionTransferType.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                            {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Grid
                                                container
                                                direction="row"
                                                justifyContent="start"
                                                alignItems="center"
                                            >
                                                <Grid item className='margin-right10px'>
                                                    {/* <Button variant="outlined" component="label" disabled={!!instruction.ti_file}>
                                                    Upload File
                                                    <input
                                                        type="file"
                                                        hidden
                                                        accept=".pdf,image/*"
                                                        onChange={(e) => uploadHandler(e, transferIndex, instructionIndex)}
                                                    />
                                                </Button> */}

                                                    <Button
                                                        component="label"
                                                        role={undefined}
                                                        variant="outlined"
                                                        tabIndex={-1}
                                                        // disabled={!!instruction.ti_file}
                                                        startIcon={<CloudUploadIcon />}
                                                    >
                                                        Upload file
                                                        <VisuallyHiddenInput
                                                            type="file"
                                                            accept=".pdf,image/*"
                                                            onChange={(e) => uploadHandler(e, transferIndex, instructionIndex)} />
                                                    </Button>
                                                </Grid>
                                                <Grid item className='margin-right10px text-wrap'>
                                                    {instruction.ti_file && (
                                                        <Typography variant="body2">
                                                            {instruction.ti_file.name ? instruction.ti_file.name : instruction.ti_file}
                                                        </Typography>
                                                    )}
                                                </Grid>
                                                <Grid item className='margin-right10px'>
                                                    {instruction.ti_file && (
                                                        <>
                                                            <IconButton title='Download' sx={{ p: "0 10px 0 0" }} onClick={() => downloadFile(item.id, instruction.id, instruction.ti_file)}>
                                                                <CloudDownload sx={{ color: '#2598c4' }} />
                                                            </IconButton>
                                                            {/* <IconButton onClick={() => deleteFile(item.id, transferIndex, instructionIndex)}>
                                                            <DeleteIcon sx={{ color: '#dd4747' }} />
                                                        </IconButton> */}
                                                        </>
                                                    )}
                                                </Grid>


                                            </Grid>
                                        </Grid>

                                        {/* <Grid item xs={12} sm={12} md={12} className='d-flex'>
                                            <Grid item xs={5} sm={5} md={5}>
                                                <label className='font15px margin-top10px font-weight500px'>Please upload the statement for any accounts you wish to transfer to us.</label>
                                            </Grid>
                                        </Grid> */}

                                        <Grid item xs={12} sm={12} md={12}>
                                            <Box
                                                sx={{
                                                    // height: 400,
                                                    marginTop: 1,
                                                    width: 1,
                                                    '& .odd': {
                                                        bgcolor: '#f5f5f5'
                                                    },
                                                    '& .even': {
                                                        bgcolor: '#eee'
                                                    }
                                                }}
                                            >
                                                <div className="file-card min-height-100px">
                                                    <ul className="file-list width100">

                                                        {instruction?.user_account_file?.length ? (
                                                            instruction.user_account_file.map((file) => {

                                                                return (
                                                                    <li key={file.id} className="file-item">
                                                                        {/* <FontAwesomeIcon icon={faFileAlt} sx={{ marginRight: "10px" }} /> */}

                                                                        <FormControlLabel
                                                                            control={
                                                                                <Checkbox
                                                                                    sx={checkboxColorSx}
                                                                                    checked={file.selected}
                                                                                    // onClick={() => handleAccountFileSelect(file)}
                                                                                    onChange={() => handleAccountFileSelect(instruction.id, file.id)}
                                                                                    aria-label={`Select file ${file.file_name}`}
                                                                                />
                                                                            }
                                                                        // label="Select"
                                                                        />
                                                                        <p className="mb-0">{file.file_name}</p>

                                                                        <FontAwesomeIcon
                                                                            className="padding6px cursor-pointer margin-left10px"
                                                                            icon={faDownload}
                                                                            onClick={() => downloadAccountFile(file.file_name, file.id)}
                                                                            title="Download file"
                                                                        />
                                                                    </li>
                                                                );
                                                            })
                                                        ) : (
                                                            <p>No files available.</p>
                                                        )}
                                                    </ul>
                                                </div>
                                            </Box>
                                        </Grid>

                                    </Grid>
                                </div>
                            ))}

                            <Grid item xs={12} sm={6} className='text-left'>
                                <Button className='text-decoration-underline' startIcon={<AddIcon />} onClick={() => addTransferInstruction(transferIndex)}>
                                    Add Transfer Instruction
                                </Button>
                            </Grid>
                        </Grid>
                    </div>
                ))}

                {hideFormData &&
                    <Grid item xs={12} sm={6} className='text-left'>
                        <Button className='text-decoration-underline' startIcon={<AddIcon />} onClick={() => addTransferDetailsTemplate()}>
                            Add Transfer Details
                        </Button>
                    </Grid>
                }

                {!hideFormData &&
                    <div className='container'>
                        <Grid item spacing={2} className='p-4'>
                            <Alert
                                severity='info'
                                className='font14px cursor-pointer'
                            // onClick={handleClickExternalInvestmentOpen}
                            >
                                This client's account(s) are not applicable for transfers.
                            </Alert>
                        </Grid>
                    </div>
                }

                <Grid item xs={12} sm={6} className='text-center'>
                    <Button variant='outlined' className='m-3' onClick={handleRoleBack}>
                        Back
                    </Button>
                    <Button variant='contained' className='m-3 raintree-btn-green' type='submit'>
                        Next
                    </Button>
                </Grid>
                {loader}
                <ToastContainer />
            </form>
        </div>
    );
};

export default TransferInformation;
